<template>
  <MyManage>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="预约记录" name="appointmentRecords" v-if="checkPermission(['bee:res:appoint:getOrderList'])">

        <AppointRecordsPage v-if="activeName=='appointmentRecords'"></AppointRecordsPage>

      </el-tab-pane>

      <el-tab-pane label="预约设置" name="appointmentSettings" v-if="checkPermission(['bee:res:appoint:getConfList'])">

        <AppointSettingPage v-if="activeName=='appointmentSettings'"></AppointSettingPage>

      </el-tab-pane>
    </el-tabs>
  </MyManage>
</template>

<script>
  import MyManage from '@/components/MyManage'
  import AppointRecordsPage from '@/module/resourceCenter/page/appointmentManager/appointmentRecords/list.vue'
  import AppointSettingPage from '@/module/resourceCenter/page/appointmentManager/appointmentSettings/list.vue'
  import ModelPage from '@/module/resourceCenter/page/car/model/list.vue'
  export default {
    name: "appointmentManager",
    components: {
      MyManage,
      AppointRecordsPage,
      AppointSettingPage,
      ModelPage
    },
    data() {
      return {
        activeName: 'appointmentRecords'
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/appointmentManager/appointmentManager.vue